import React, { useEffect, useState } from 'react';
import { VideoCard } from './VideoCard';
import { CategoryChips } from './CategoryChips';
import { Header } from './Header';
// Videos from user-provided URLs
const placeholderVideos = [{
  id: '1',
  title: 'How I Animated My First Short Film',
  videoId: 'LCEMiRjPEtQ',
  channelName: 'Andrei Kovalev',
  channelVerified: true,
  views: '2.7M views',
  timestamp: '1 year ago',
  duration: '12:36'
}, {
  id: '2',
  title: 'How to Start a Startup (The Lean Approach)',
  videoId: 'Th8JoIan4dg',
  channelName: 'Y Combinator',
  channelVerified: true,
  views: '293K views',
  timestamp: '2 years ago',
  duration: '44:28'
}, {
  id: '3',
  title: 'How to Create a Minimum Viable Product | Michael Seibel',
  videoId: 'ASABxNenD_U',
  channelName: 'Y Combinator',
  channelVerified: true,
  views: '178K views',
  timestamp: '1 year ago',
  duration: '12:53'
}, {
  id: '4',
  title: 'Figma Tutorial - A Free UI Design/Prototyping Tool',
  videoId: 'wv779vmyPVY',
  channelName: 'DesignCourse',
  channelVerified: true,
  views: '1.2M views',
  timestamp: '3 years ago',
  duration: '23:46'
}, {
  id: '5',
  title: 'I Survived 50 Hours In Antarctica',
  videoId: '7IKab3HcfFk',
  channelName: 'MrBeast',
  channelVerified: true,
  views: '187M views',
  timestamp: '6 months ago',
  duration: '14:36'
}, {
  id: '6',
  title: 'How To Learn Anything Fast',
  videoId: '4SNThp0YiU4',
  channelName: 'Thomas Frank',
  channelVerified: true,
  views: '1.4M views',
  timestamp: '1 year ago',
  duration: '10:55'
}, {
  id: '7',
  title: 'The BEST Studio Ghibli Movie?',
  videoId: '_sZH-psg9yE',
  channelName: 'Beyond Ghibli',
  channelVerified: false,
  views: '815K views',
  timestamp: '1 year ago',
  duration: '17:23'
}, {
  id: '8',
  title: 'The Future of AI: OpenAI CEO Sam Altman | Lex Fridman Podcast',
  videoId: '7j_NE6Pjv-E',
  channelName: 'Lex Fridman',
  channelVerified: true,
  views: '5.1M views',
  timestamp: '9 months ago',
  duration: '2:14:25'
}, {
  id: '9',
  title: 'Crash Course Computer Science: Programming Basics',
  videoId: '_qr7ogLpTJs',
  channelName: 'Crash Course',
  channelVerified: true,
  views: '1.8M views',
  timestamp: '4 years ago',
  duration: '11:47'
}, {
  id: '10',
  title: 'The Science of Well-Being | Yale University',
  videoId: 'ZAWvRqQwvSM',
  channelName: 'Yale Courses',
  channelVerified: true,
  views: '3.2M views',
  timestamp: '2 years ago',
  duration: '56:22'
}, {
  id: '11',
  title: 'How to Make a Personal Website in 2023 (Step by Step Guide)',
  videoId: 'ZA9K0JMrbWg',
  channelName: 'ForrestKnight',
  channelVerified: true,
  views: '422K views',
  timestamp: '7 months ago',
  duration: '18:34'
}, {
  id: '12',
  title: 'The Most Powerful Mindset for Success',
  videoId: 'U9DyHthJ6LA',
  channelName: 'TEDx Talks',
  channelVerified: true,
  views: '7.5M views',
  timestamp: '3 years ago',
  duration: '15:51'
}];
export const VideoGrid = ({
  customVideos = [],
  onRemoveVideo,
  onUpdateVideo
}) => {
  const [shuffledVideos, setShuffledVideos] = useState([]);
  const [initializedIds, setInitializedIds] = useState(new Set());
  const [sidebarOpen, setSidebarOpen] = useState(true);
  // Function to shuffle array (Fisher-Yates algorithm)
  const shuffleArray = array => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };
  // Prepare videos for display
  useEffect(() => {
    console.log('VideoGrid received customVideos count:', customVideos.length);
    if (customVideos.length > 0) {
      console.log('Sample custom video:', {
        id: customVideos[0].id,
        title: customVideos[0].title,
        videoId: customVideos[0].videoId,
        hasCustomThumbnail: Boolean(customVideos[0].customThumbnail),
        isCustom: customVideos[0].isCustom
      });
    }
    // Check if we have new videos that weren't previously initialized
    const currentIds = new Set(customVideos.map(video => video.id));
    const hasNewVideos = customVideos.some(video => !initializedIds.has(video.id));
    const removedVideos = Array.from(initializedIds).some(id => !currentIds.has(id));
    // Only reshuffle if we have new videos or videos were removed
    if (hasNewVideos || removedVideos || shuffledVideos.length === 0) {
      // Preserve all properties of custom videos, especially customThumbnail
      const customWithFlags = customVideos.map(video => ({
        ...video,
        isCustom: true
      }));
      // Combine all videos
      const allVideos = [...customWithFlags, ...placeholderVideos];
      setShuffledVideos(shuffleArray(allVideos));
      // Update our initialized IDs set
      setInitializedIds(currentIds);
    } else {
      // Just update the existing videos without reshuffling
      setShuffledVideos(prevVideos => {
        return prevVideos.map(video => {
          // If this is a custom video that was updated, get the updated version
          if (video.isCustom) {
            const updated = customVideos.find(cv => cv.id === video.id);
            if (updated) {
              return {
                ...updated,
                isCustom: true
              };
            }
          }
          return video;
        });
      });
    }
  }, [customVideos]);
  const handleTitleUpdate = (id, newTitle) => {
    if (onUpdateVideo) {
      onUpdateVideo(id, {
        title: newTitle
      });
    }
  };
  return <div className="flex flex-col h-full" data-id="element-362">
      {/* Add the Header component at the top of the YouTube view */}
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} data-id="element-363" />
      <div className="mt-4" data-id="element-364">
        <div className="flex justify-between items-center" data-id="element-365">
          <CategoryChips data-id="element-366" />
        </div>
        <div className="mt-4" data-id="element-367">
          <div className="grid grid-cols-1 sm:grid-cols-2 min-[1000px]:grid-cols-3 gap-x-4 gap-y-6" data-id="element-368">
            {shuffledVideos.map(video => {
            // Add debug log for each video being rendered
            if (video.isCustom) {
              console.log('Rendering custom video card:', {
                id: video.id,
                title: video.title,
                videoId: video.videoId,
                hasCustomThumbnail: Boolean(video.customThumbnail)
              });
            }
            return <VideoCard key={video.id} id={video.id} title={video.title} videoId={video.videoId} channelName={video.channelName} channelVerified={video.channelVerified} views={video.views} timestamp={video.timestamp} duration={video.duration} customThumbnail={video.customThumbnail} isCustom={video.isCustom} onRemove={video.isCustom ? () => onRemoveVideo(video.id) : undefined} onTitleUpdate={video.isCustom ? handleTitleUpdate : undefined} data-id="element-369" />;
          })}
          </div>
        </div>
      </div>
    </div>;
};